import styled from 'styled-components'

export const StyledForm = styled.form`
  padding: 24px 0;
  max-height: 70vh;
  overflow-y: auto;
`

export const FormSection = styled.div`
  margin-bottom: 24px;
`

export const FullWidthFieldWrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;

  .field-wrapper {
    flex-direction: column;
    align-items: flex-start;
    margin: 0;

    .field-label {
      width: auto;
      text-align: left;
      margin-right: 0;
      margin-bottom: 8px;
      justify-content: flex-start;
    }

    .field-control {
      width: 100%;
      max-width: none;
    }
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 10;
`

export const OfferUrlWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
`

export const ImageUploadSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  background-color: #fafafa;
  transition: border-color 0.3s;

  &:hover {
    border-color: #40a9ff;
  }
`

export const ImagePreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;

  .ant-image {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    overflow: hidden;
  }
`
